import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from 'common/reducers';
import { AppEnvs } from 'enums';

function configureStore(initialState = { app: {} }, history, customMiddleware = []) {
    const middleware = [thunkMiddleware, routerMiddleware(history)].concat(customMiddleware);
    if (process.browser && process.env.NODE_ENV !== 'production') {
        // turn this off by default
        // const createLogger = require('redux-logger');
        // middleware.push(createLogger());
    }

    const store = createStore(rootReducer, initialState, compose(
        applyMiddleware(...middleware),
        (
            typeof window === 'object' &&
            typeof window.devToolsExtension !== 'undefined' &&
            initialState.app.env !== AppEnvs.PROD
        ) ? window.devToolsExtension() : func => func
    ));

    if (process.env.NODE_ENV !== 'production' && module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept('common/reducers', () => {
            const nextReducer = require('common/reducers');
            store.replaceReducer(nextReducer);
        });
    }

    return store;
}

export default configureStore;



// WEBPACK FOOTER //
// ./app/store.js